<script setup>
import { ref } from 'vue';
import PurchaseProjectsPanel from './PurchaseProjectsPanel.vue';

defineProps({
  contactId: {
    type: [String, Number],
    required: true,
  },
  contactName: {
    type: String,
    default: '',
  },
  contactPhone: {
    type: String,
    default: '',
  },
  contactEmail: {
    type: String,
    default: '',
  },
  contactPreferredChannel: {
    type: String,
    default: 'whatsapp',
  },
});

const emit = defineEmits([
  'projectCreated',
  'projectUpdated',
  'returnToCloseCircle',
]);

const isOpen = ref(false);
const panelRef = ref(null);

const open = () => {
  panelRef.value?.showList();
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
};

const requestClose = () => {
  panelRef.value?.requestClose?.();
};

const openProject = (project, options = {}) => {
  isOpen.value = true;
  panelRef.value?.openProject(project, options);
};

const addProject = project => {
  panelRef.value?.addProject(project);
};

const returnToCloseCircle = context => {
  close();
  emit('returnToCloseCircle', context);
};

defineExpose({ open, close, openProject, addProject });
</script>

<template>
  <div
    class="fixed inset-0 z-[60] flex items-end justify-center pointer-events-none transition-colors duration-200 ease-in-out"
    :class="
      isOpen
        ? 'pointer-events-auto bg-n-alpha-black1 backdrop-blur-[4px]'
        : 'bg-transparent'
    "
    @click.self="requestClose"
  >
    <div
      class="w-full sm:max-w-xl h-[92vh] max-h-[92vh] pointer-events-auto bg-n-solid-2 overflow-y-auto rounded-t-[1.5rem] sm:rounded-t-2xl shadow-xl transition-transform duration-200 ease-in-out"
      :class="isOpen ? 'translate-y-0' : 'translate-y-full'"
    >
      <PurchaseProjectsPanel
        ref="panelRef"
        :contact-id="contactId"
        :contact-name="contactName"
        :contact-phone="contactPhone"
        :contact-email="contactEmail"
        :contact-preferred-channel="contactPreferredChannel"
        @close-sheet="close"
        @project-created="project => emit('projectCreated', project)"
        @project-updated="project => emit('projectUpdated', project)"
        @return-to-close-circle="returnToCloseCircle"
      />
    </div>
  </div>
</template>
